import { useHistory, useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import cookies from 'js-cookie';
import { Toaster } from 'react-hot-toast';

import { cookieNames, pageRedirect } from '@monorepo/common';

import Layout from './containers/Layout';
import { AppShell } from './components/layout/app-shell';
import { useAppSelector } from './store/hooks';
import RootRouters from './routers/RootRouters';
import Notification from './components/Notification';
import { ProjectNavigation } from './components/ProjectNavigation';
import { book } from './routers/books';
import { useAuthStore } from './stores/auth-store';
import { useGetPublicProfile } from './hooks/use-user-profile';
import { breweryLoginUrl, breweryReturnUrl } from './pages/breweries/api';

function App() {
  const location = useLocation();
  const { showNotification } = useAppSelector(
    ({ notification }) => ({
      showNotification: notification.show,
    })
  );
  const {
    location: { pathname },
  } = useHistory();
  const dispatch = useDispatch();

  // Use Zustand auth store
  const { isAuth, setAuth } = useAuthStore();

  // Fetch public profile when authenticated (replaces RTK Query)
  useGetPublicProfile(isAuth);

  // GLOBAL INIT - Check auth status based on cookie
  useEffect(() => {
    if (cookies.get(cookieNames.bevnet_token)) {
      setAuth(true);
      return;
    }
    setAuth(false);
  }, [pathname, setAuth]);

  // if cookie not exist, redirect page
  useEffect(() => {
    let clearPath = pathname;
    if (clearPath.endsWith('/') && clearPath !== '/') {
      clearPath = clearPath.slice(0, -1);
    }

    if (!cookies.get(cookieNames.bevnet_token)
        && clearPath !== book.invoices.invoice
        && clearPath !== book.invoices.confirmEmail
        && clearPath !== book.invoices.invoiceCompleted) {
      if (/^\/breweries(?:\/|$)/i.test(clearPath)) window.location.assign(breweryLoginUrl(breweryReturnUrl()));
      else pageRedirect({ token: cookies.get(cookieNames.bevnet_token) });
    }
    if (clearPath === book.invoices.invoice
        && !cookies.get(cookieNames.bevnet_token)
        && !cookies.get(cookieNames.invoice_token)) {
      window.location.href = '/invoice/confirmEmail';
    }
  }, [location, pathname]);

  return (
    <>
      {showNotification && <Notification />}
      <Toaster position="bottom-right" />

      {/* Use new AppShell layout when authenticated */}
      {isAuth ? (
        <AppShell>
          <RootRouters />
        </AppShell>
      ) : (
        <Layout
          isAuth={isAuth}
          projectNavigation={<ProjectNavigation />}
        >
          <RootRouters />
        </Layout>
      )}
    </>
  );
}

export default App;
